import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadChildren } from './actions';
import List from './List';

class Children extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const parentId = this.props.parentId;
		this.props.loadData({ parentId, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleListEvent(listPagination) {
		const parentId = this.props.parentId;
		this.props.loadData({ parentId, ...listPagination });
	}

	render() {
		return (
			<List parentId={this.props.parentId} onFetchData={this.handleListEvent} data={this.props.data} {...this.props.pagination} />
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const {
		pagination,
		entities: { children } } = state;

	const childrenPagination = pagination.childrenByParent[ownProps.parentId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: childrenPagination.ids.map(id => children[id]),
		pagination: childrenPagination
	};
};

Children.propTypes = {
	parentId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadChildren
})(Children);